import { APP_CONFIG } from 'core';

/**
 * remove the app domain from the path if it exists in pathname
 *
 */
export function removeAppDomainFromPath(path: string) {
  return (path || '').replace(APP_CONFIG.url, '');
}
